import React from 'react';
import { RotateCcw, Search } from 'lucide-react';
import { RANGES } from '../../calls/callModel';
import { DURATIONS } from '../recordingsModel';

/** Search, call type, date range (with custom dates), duration, team member, tag and Reset: all applied together. */
export default function RecordingFilters({ search, onSearch, filters, onChange, onReset, agents, tags }) {
  const set = (k) => (e) => onChange({ ...filters, [k]: e.target.value });
  return (
    <div className="panel cl-filters">
      <label className="cl-search"><Search size={15} /><input value={search} onChange={(e) => onSearch(e.target.value)} placeholder="Search by phone number or contact name…" aria-label="Search recordings" /></label>
      <label className="cl-field">Call Type<select value={filters.direction} onChange={set('direction')}>
        <option value="">All calls</option><option value="inbound">Incoming</option><option value="outbound">Outgoing</option></select></label>
      <label className="cl-field">Date Range<select value={filters.range} onChange={set('range')}>
        <option value="">Any date</option>{Object.entries(RANGES).map(([k, [label]]) => <option key={k} value={k}>{label}</option>)}</select></label>
      {filters.range === 'custom' && (
        <>
          <label className="cl-field">From<input type="date" value={filters.from} max={filters.to || undefined} onChange={set('from')} /></label>
          <label className="cl-field">To<input type="date" value={filters.to} min={filters.from || undefined} onChange={set('to')} /></label>
        </>
      )}
      <label className="cl-field">Duration<select value={filters.duration} onChange={set('duration')}>
        {DURATIONS.map(([k, label]) => <option key={k} value={k}>{label}</option>)}</select></label>
      <label className="cl-field">Agent / Team<select value={filters.agent} onChange={set('agent')}>
        <option value="">All members</option>{(agents || []).map((a) => <option key={a.id} value={a.id}>{a.name || `Member #${a.id}`}</option>)}</select></label>
      <label className="cl-field">Tags<select value={filters.tag} onChange={set('tag')}>
        <option value="">All tags</option>{(tags || []).map((t) => <option key={t} value={t}>{t}</option>)}</select></label>
      <button type="button" className="secondary-action cl-reset" onClick={onReset}><RotateCcw size={13} />Reset</button>
    </div>
  );
}
